import React, {type Dispatch, useRef, useState, useEffect} from 'react'
import { useMsal,   } from "@azure/msal-react";
import { AccountInfo, InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";
import {  Typography, Box, keyframes} from '@mui/material';
import { useMediaPredicate } from 'react-media-hook';

//internal imports
import { authenticatedFetch } from '../Helper/Fetch/fetch';
import {useSkidConfig, useSkidConfigDispatch} from '../components/AvailableSkids/SkidsProvider'
import {determineDisplayName, Skid, useSkidsWithConfig, useSkidsWithConfigDispatch} from '../components/AvailableSkids/skidsWithConfigProvider'
import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import { loginRequest, protectedResources } from "../authConfig";
import InfoBox from '../components/Landing/Info';
import { getConfigurl, getRheoServerUrl } from "../Config/config";
import { SkidCard } from '../components/Landing/SkidCard';
import { isPopulated, toSelectOptions } from '../components/AvailableSkids/skidsHelpers';




const fetchSkids = async(accounts:AccountInfo[], instance:IPublicClientApplication, skidDispatch:Dispatch<any>, TrackerDispatch:Dispatch<any>) =>{
    const configURL = 'https://rheoport-api.azurewebsites.net'
    var fetchURL = configURL+"/GetAvailableSkids"
        console.log(`Hello ${accounts[0].name} your email is: ${accounts[0].username}`)
        var params = {}
        const request = {
          scopes: protectedResources.whoami.scopes,
          account: accounts[0]
        }
    
        var req = authenticatedFetch(request,instance,params,fetchURL)
        console.log('instance:',instance)
        req.then(res => res.json())
        .then((items) =>{
          console.log("available skids: ", items.skids);
          skidDispatch({
            type:'addSkids',
            skids:items.skids
          })
          TrackerDispatch({
            type:'skid',
            value:true
          })
          
        }).catch((error)=>{
            console.error("Error fetching skids:", error)
          })  
}
const fetchSkidsWithConfig = async(accounts:AccountInfo[], instance:IPublicClientApplication, skidDispatch:Dispatch<any>, TrackerDispatch:Dispatch<any>) =>{
  const configURL = getConfigurl()
  //var fetchURL = configURL+"/GetAvailableSkidsWithConfig"
  var fetchURL = configURL+"/GetUserSkidsWithHeaders"
   var params = {}
        const request = {
          scopes: protectedResources.whoami.scopes,
          account: accounts[0]
        }  
  var  req = authenticatedFetch(request,instance,params,fetchURL).then(
    res => res.json()).then((items)=>{
       console.log("available skids with config: ", items);
          skidDispatch({
            type:'addSkidsWithConfig',
            skid:null,
            skids:items
          })
          TrackerDispatch({
            type:'skidsWithConfig',
            value:true
          })
    }).catch((error)=>{
            console.error("Error fetching skids:", error)
            
            instance.loginRedirect(loginRequest).catch(e => {
            console.log("login error redirect", e)
            //console.error(e);
        });
          })

}
export type SkidHeader ={
  Name:string,
  Operator:string,
  Country:string,
  IMSContact:string,
  WellName:string,
  Field:string,
  RigName:string
  RigType:string
}
export type SkidHeaders = {[index:string]:SkidHeader
}
function statusToNumber(status:string):number{
  switch(status.toLowerCase()){
      case 'active':
          return 3
      case 'idle':
          return 2
      case 'disconnected':
          return 1
      default:
          return 0
  }
}
function getSkidByName(skids:Map<string,Skid>, name:string):Skid|null{
    for (const skid of skids.values()){
        if (skid.name === name){
            return skid
        }  
      } 
    return null
}

function manualSortSkids(skids:Map<string,Skid>, skidsStatus:{[index:string]:string}):Map<string,Skid>{
    let sortedSkids = new Map<string,Skid>()
    const activeSkids = []
    const idleSkids = []
    const disconnectedSkids = []
    const unknownSkids = []
    for (const skidName in skidsStatus){
       // console.log("checking skid:", skidName, "with status:", skidsStatus[skidName])
            const skid = getSkidByName(skids, skidName)
         //   console.log("found skid:", skid)
            if (skid){
                skid.status = skidsStatus[skidName]
                switch(skidsStatus[skidName].toLowerCase().trim()){
                    case 'running':
           //             console.log("pushing running skid:", skid.name)
                        activeSkids.push(skid)
                        break
                    case 'idle':
                        //console.log("pushing idle skid:", skid.name)
                        idleSkids.push(skid)
                        break
                    case 'disconnected':
                        //console.log("pushing disconnected skid:", skid.name)
                        disconnectedSkids.push(skid)
                        break
                    default:
                        //console.log("pushing unknown skid:", skid.name)
                        unknownSkids.push(skid)
                
            }
        }
    }
    activeSkids.forEach(skid => sortedSkids.set(determineDisplayName(skid),skid))
    idleSkids.forEach(skid => sortedSkids.set(determineDisplayName(skid),skid))
    disconnectedSkids.forEach(skid => sortedSkids.set(determineDisplayName(skid),skid))
    unknownSkids.forEach(skid => sortedSkids.set(determineDisplayName(skid),skid))
    return sortedSkids
}
function sortSkidsByStatus(skids:Map<string,Skid>, skidsStatus:{[index:string]:string}):Map<string,Skid>{
  console.log("sorting skids by status:", skidsStatus)
  for (const skidName in skidsStatus){
    if (skids.has(skidName)){
        const skid = skids.get(skidName)
        if (skid){
            skid.status = skidsStatus[skidName]
            skids.set(skidName,skid)
        }
    }
    }
  let sortedSkids = new Map<string,Skid>(
        Array.from(skids).sort((a,b)=>{
            const statusA = a[1].status ? statusToNumber(a[1].status) : 0
            const statusB = b[1].status ? statusToNumber(b[1].status) : 0
            return statusB - statusA
        })
    )
    console.log("sorted skids:", sortedSkids)
    return sortedSkids
}
const fetchSkidHeaders = async(accounts:AccountInfo[], instance:IPublicClientApplication, setSkidHeaders:React.Dispatch<React.SetStateAction<SkidHeaders>>, TrackerDispatch:Dispatch<any>) =>{
    const configURL = getConfigurl()
    const fetchURL = configURL+"/GetSkidHeaders"
    const params = {
    }
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0]
    }
    var req = authenticatedFetch(request,instance,params,fetchURL).then(
    res => res.json()).then((items)=>{
       console.log("available headers: ", items);
         setSkidHeaders(items)
          TrackerDispatch({
            type:'skidHeaders',
            value:true
          })
    }) 
   
}
const fetchStatusForSkids = async(accounts:AccountInfo[], instance:IPublicClientApplication, setSkidsStatus:React.Dispatch<React.SetStateAction<{[index:string]:string}>>) =>{
    const rheoserverURL = getRheoServerUrl()
    const fetchURL = rheoserverURL+"/GetStatus"
    const params = {
    }
    const request = {
      scopes: protectedResources.whoami.scopes,
      account: accounts[0]
    }
    authenticatedFetch(request,instance,params,fetchURL).then(
    res => res.json()).then((items)=>{
        console.log("skid statuses: ", items);
        setSkidsStatus(items)
    }).catch((error)=>{
      console.error("Error fetching skid statuses:", error)
    })
}

function Landing() {
    
    const { instance, accounts, inProgress } = useMsal();
    const SkidDispatch = useSkidConfigDispatch()
    const Skids = useSkidConfig()
    const TrackerDispatch = useTrackerDispatch()
    const Tracker = useTracker()
    const SkidWithConfigDispatch = useSkidsWithConfigDispatch()
    const SkidsWithConfig = useSkidsWithConfig()
    const skidsFetchRef = useRef<boolean>(false)
    const skidsWithConfigFetchRef = useRef<boolean>(false)
    const skidHeaderFetchRef = useRef<boolean>(false)
    const [skidHeaders, setSkidHeaders] = useState<SkidHeaders>({})
    const [skidsStatus, setSkidsStatus] = useState<{[index:string]:string}>({})
    const minute_ms = 60*1000
    const statusUpateInterval = 15
    const isMobile = useMediaPredicate("(max-width: 600px)");
    let width = '80%'
    if (isMobile){
        width = '95%'
    }
    //checks if user is logged in and fetches users info when logged in
    if(accounts[0] && inProgress === "none"){
      //checks if there are any skids and if skids has been fetched and that there is not fetch in progress
        if(!isPopulated(Skids) && !Tracker.skid && !skidsFetchRef.current){
          //console.log('fetching skids')
          skidsFetchRef.current = true
          //fetchSkids(accounts, instance, SkidDispatch, TrackerDispatch)
        }
        if(!isPopulated(SkidsWithConfig)&& !Tracker.skidsWithConfig && !skidsWithConfigFetchRef.current){
          console.log('user has no skids with config, fetching skids with config')
          console.log('accounts:', accounts[0])
          console.log('fetching skids with config')
          skidsWithConfigFetchRef.current = true
          fetchSkidsWithConfig(accounts, instance, SkidWithConfigDispatch, TrackerDispatch)
        }
        if(Object.keys(skidHeaders).length === 0 && !skidHeaderFetchRef.current){
          //console.log('fetching skid headers')
          skidHeaderFetchRef.current = true
          //fetchSkidHeaders(accounts, instance, setSkidHeaders, TrackerDispatch)
        }  
    }
    // starts a timer to refetch skid status every x minute
    useEffect(()=>{
      console.log('fetching initial skid status')
      fetchStatusForSkids(accounts, instance, setSkidsStatus)
      //console.log('setting up interval to refetch skid status every', statusUpateInterval, 'minute(s)')
      const interval = setInterval(()=>{
        if(accounts[0]){
          console.log('time to refetch skid status')
          fetchStatusForSkids(accounts, instance, setSkidsStatus)
        }
      }, minute_ms*statusUpateInterval)
      return () => clearInterval(interval)
    },[])
    //console.log('Rendering Landing Page')
    //console.log('Header data:', skidHeaders)
    
    return (
        <div className='Landing-Box' style={{width:width, margin:'auto', marginTop:'20px', marginBottom:'20px',}}>
          <InfoBox name={accounts[0].name} email={accounts[0].username}/>
          <div style={{display:'flex',flexWrap:'wrap',flexDirection:'row', justifyContent:'space-between'}}>
            {Array.from(manualSortSkids(SkidsWithConfig, skidsStatus)).map((skid,index)=>{
                return (
                    <div key={index} className='Skid-Box'> <SkidCard skid={skid[1]} skidHeader={skidHeaders[skid[1].name]} skidStatus={skidsStatus[skid[1].name]}/>
                    </div>
                )
            })}
          </div> 
        </div>
    )
            

};

export default Landing